module.exports = "<div *ngIf=\"mostrarBloqueio\" class=\"backdrop-bloqueio\">\n  <span class=\"texto-bloqueio\">Entre em contato com sua academia para alterar a opção de pagamento</span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/checkout/components/checkout/backdrop-bloqueio/backdrop-bloqueio.component.html
// module id = ./src/app/modules/checkout/components/checkout/backdrop-bloqueio/backdrop-bloqueio.component.html
// module chunks = main